/* eslint-disable */
import React from 'react'
import {message} from 'antd'
import http from '../../Component/Interceptor/Interseptor'
import jMoment from 'moment-jalaali'
import HeaderTablePrint from '../BaseComponent/HeaderTablePrint'
import {Modal, ModalBody, ModalFooter, ModalHeader} from 'mdbreact'
import $ from 'jquery'
import {Link} from 'react-router-dom'
import cookie from 'react-cookies'
import BASE_REPORT from '../BaseComponent/BASEREPORT'
import BASE_MANAGE from '../BaseComponent/BASEMANAGE'
import ExcelExport from '@progress/kendo-react-excel-export/dist/npm/ExcelExport'
import HeaderGrid from '../Pagination/HeaderGrid'
import Sort from '../Pagination/Sort'
import Pageing from '../Pagination/pageing'

class Cars extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      cars: [],
      printInfo: [],
      lengthProducts: 0,
      pageNumber: 1,
      pageSize: 10,
      sortBy: '',
      getSort: '',
      modalDelete: false,
      modalEdit: false,
      sortData: [
        {
          name: 'ردیف',
          value: 'id',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'نام خودرو',
          value: 'name',
          sorted: false,
          direction: null,
          sortable: true
        },
        {
          name: 'توضیحات',
          value: 'description',
          sorted: false,
          direction: null,
          sortable: false
        },

        {
          name: 'وضعیت فعال',
          value: 'id',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'ویرایش',
          value: 'id',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'حذف',
          value: 'id',
          sorted: false,
          direction: null,
          sortable: false
        }
      ]
    }
  }

  getCarTypes = (exportStatus) => {
    let filter = this.createFilter(exportStatus)
    http
      .get(`${BASE_REPORT.BASE_REPORT_CAR}`, {
        params: filter
      })
      .then((response) => {
        if (response.data.error == null) {
          // this.setState({
          // cars: response.data.object.result
          // ,
          // lengthProducts: response.data.object.countAll
          // })
          $('.showBaseTable').fadeIn()
          if (!exportStatus) {
            this.setState({
              cars: response.data.object.result,
              lengthProducts: response.data.object.countAll
            })
          } else if (exportStatus) {
            this.setState({
              printInfo: response.data.object.result
            })
          }
        } else {
          $('.showBaseTable').fadeOut()
        }
        // alert(JSON.stringify(response.data))
      })
    // .catch((error) => {
    //     alert(JSON.stringify(error))
    // })
  }

  componentDidMount() {
    $(function() {
      $('.filterBtn').on('click', function() {
        $('.filterComponent').slideToggle()
      })

      $('.cancelFilter').click(function() {
        $('.filterComponent').slideUp()
      })
    })

    // sessionStorage.setItem('pageNumber', '1');
    // sessionStorage.setItem('dropDownVal', '10');
    // sessionStorage.setItem('params', '');
    this.getCarTypes(false)
  }

  changeDropDown(data) {
    this.setState({
      cars: data,
      lengthProducts: this.state.lengthProducts
    })
  }

  activate = (numRow) => {
    let status = this.state.cars[numRow].enabled
    if (status) {
      let id = this.state.cars[numRow].carId
      let data = {
        id: id
      }

      http
        .post(`${BASE_MANAGE.BASE_MANAGE_TYPE_DISABLE_CAR}`, data, {})
        .then((response) => {
          // alert(JSON.stringify(response.data))
          if (response.data.error == null && response.data.object == 'SUCCESS') {
            this.getCarTypes(false)
          } else {
            message.error('عملیات تغییر وضعیت اتومبیل موفق نبود')
          }
        })
        .catch((error) => {
          alert(JSON.stringify(error))
        })
    } else {
      let id = this.state.cars[numRow].carId
      let data = {
        id: id
      }

      http
        .post(`${BASE_MANAGE.BASE_MANAGE_TYPE_ENABLE_CAR}`, data, {})
        .then((response) => {
          if (response.data.error == null && response.data.object == 'SUCCESS') {
            this.getCarTypes(false)
          } else {
            message.error('عملیات تغییر وضعیت اتومبیل موفق نبود')
          }
        })
        .catch((error) => {
          alert(JSON.stringify(error))
        })
    }
  }

  deleteCar = (numId) => {
    let carId = this.state.cars[numId].id
    let carName = this.state.cars[numId].name
    sessionStorage.setItem('carId', carId)
    sessionStorage.setItem('carName', carName)
    this.setState({
      modalDelete: !this.state.modalDelete
    })
  }
  deleteCancel = () => {
    this.setState({
      modalDelete: !this.state.modalDelete
    })
    sessionStorage.removeItem('carId')
    sessionStorage.removeItem('carName')
  }

  deleteOk = () => {
    let carId = sessionStorage.getItem('carId')
    let data = {
      id: carId
    }
    http
      .post(`${BASE_MANAGE.BASE_MANAGE_TYPE_DELETE_CAR}`, data, {})
      .then((response) => {
        if (response.data.error == null && response.data.object == 'SUCCESS') {
          this.getCarTypes()

          message.success('خودرو با موفقیت حذف شد')
          this.setState({
            modalDelete: !this.state.modalDelete
          })
        } else {
          message.error(JSON.stringify('خطای ' + response.data.errorCode + ' : ' + response.data.description))
          this.setState({
            modalDelete: !this.state.modalDelete
          })
        }
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })
  }

  editCarType = (numId) => {
    let carId = this.state.cars[numId].id
    let carName = this.state.cars[numId].name
    let description = this.state.cars[numId].description
    sessionStorage.setItem('carId', carId)
    sessionStorage.setItem('carName', carName)
    sessionStorage.setItem('description', description)
    this.setState({
      modalEdit: !this.state.modalEdit
    })
  }
  EditCancel = () => {
    this.setState({
      modalEdit: !this.state.modalEdit
    })
    sessionStorage.removeItem('carId')
    sessionStorage.removeItem('carName')
    sessionStorage.removeItem('description')
  }
  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevState.pageNumber !== this.state.pageNumber) {
      this.getCarTypes(false)
    }
    if (prevState.pageSize !== this.state.pageSize) {
      this.getCarTypes(false)
    }
    if (prevState.sortBy !== this.state.sortBy) {
      this.getCarTypes(false)
    }
  }

  getPageNumber = (pageNumber) => {
    this.setState({
      pageNumber
    })
  }

  getPageSize = (pageSize) => {
    this.setState({
      pageSize,
      pageNumber: 1
    })
  }

  getSort = (sortBy) => {
    this.setState({
      sortBy
    })
  }

  EditOk = () => {
    let carId = sessionStorage.getItem('carId')
    var name = document.getElementById('name').value
    var description = document.getElementById('description').value
    var nameError = false
    var descriptionError = false
    var formError = false
    if (name == '') {
      formError = true
      nameError = true
      message.error('نام نوع خودرو وارد شود')
    } else {
      if (!nameError) {
        this.setState({
          error: ''
        })
      }
    }

    if (description == '') {
      formError = true
      descriptionError = true
      message.error('یک توضیح مختصر برای خودرو وارد کنید')
    } else {
      if (!descriptionError) {
        this.setState({
          error: ''
        })
      }
    }

    if (!formError) {
      let data = {
        carId: carId,
        name: name,
        description: description
      }

      http
        .post(`${BASE_MANAGE.BASE_MANAGE_TYPE_EDIT_CAR_INFO}`, data)
        .then((response) => {
          if (response.data.error == null) {
            this.getCarTypes()

            message.success('خودرو ویرایش شد')
            this.setState({
              modalEdit: !this.state.modalEdit
            })
          } else {
            message.error('خطای ' + response.data.errorCode + ' : ' + response.data.description)
          }
        })
        .catch((error) => {
          alert(JSON.stringify(error))
        })
    }
  }
  createFilter = (exportStatus) => {
    let filter = {}
    let name = $('#filterName').val()
    filter.pageNumber = this.state.pageNumber
    filter.pageSize = this.state.pageSize
    filter.export = exportStatus
    if (this.state.sortBy !== '') {
      filter.sortBy = this.state.sortBy
    }
    if (name != '' && name.length) {
      filter.name = name
    }

    return filter
  }

  filter() {
    this.getCarTypes(false)
  }
  exportExcel = () => {
    let filter = this.createFilter(true)

    http
      .get(`${BASE_REPORT.BASE_REPORT_CAR}`, {
        params: filter
      })
      .then((response) => {
        // alert(JSON.stringify(response.data))
        if (response.data.error == null) {
          this.setState({
            excelReport: response.data.object.result
          })
          let {excelReport} = this.state

          for (let i = 0; i < excelReport.length; i++) {
            if (excelReport[i]['enabled']) {
              excelReport[i]['enabled'] = 'فعال'
            } else {
              excelReport[i]['enabled'] = 'غیر فعال'
            }
          }

          this._export.save(this.state.excelReport)
        } else {
          this.setState({
            excelReport: []
          })
        }
      })
      .catch((error) => {
        // alert(JSON.stringify(error))
      })

    // this._export.save(excelData)
  }

  getPrintInfo = () => {
    this.getCarTypes(true)

    // http.get(`${BASE_REPORT.BASE_REPORT_CAR}?export=true&${sessionStorage.getItem('params')}`, {}).then((response) => {
    //     if (response.data.error == null) {

    //         this.setState({
    //             printInfo: response.data.object.result
    //         })
    //     }
    // }).catch((error) => {
    //     alert(JSON.stringify(error))
    // });
  }

  exportPrint = () => {
    var css = '@page { size:A4 portrait;}',
      head = document.head || document.getElementsByTagName('head')[0],
      style = document.createElement('style')

    style.type = 'text/css'
    style.media = 'print'

    if (style.styleSheet) {
      style.styleSheet.cssText = css
    } else {
      style.appendChild(document.createTextNode(css))
    }

    head.appendChild(style)
    this.getPrintInfo()
    setTimeout(() => {
      window.print()
    }, 2000)
  }

  render() {
    let {pageNumber, pageSize} = this.state

    let excelColumns = [{title: 'نام ', value: 'name'}, {title: 'توضیحات', value: 'description'}]
    let dropDownVal = sessionStorage.getItem('dropDownVal')

    const carName = sessionStorage.getItem('carName')
    const description = sessionStorage.getItem('description') == null ? '' : sessionStorage.getItem('description')
    let name = cookie.load('name')
    let columns = ['ردیف', 'نام', 'توضیحات ', 'وضعیت فعال']
    return (
      <div className="rtl printA4Page">
        <div className="printSection">
          <table className="printTable printReportTable" ref={(node) => (this.printPart = node)}>
            <HeaderTablePrint
              header="لیست نوع خودرو ها"
              headerColSpan={4}
              reporter={name}
              timePrint={jMoment().format('jYYYY/jM/jD HH:mm')}
              leftColSpan={2}
              rightColSpan={1}
              centerColSpan={1}
              centerSection={''}
              rightSection={''}
              columns={columns}
            />

            <tbody>
              {this.state.printInfo.map((cars, index) => (
                <tr key={'i' + index}>
                  <td>{index + 1}</td>
                  <td>{cars.name}</td>
                  <td>{cars.description}</td>
                  <td>{cars.enabled ? 'فعال' : 'غیر فعال'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="excelSection">
          <ExcelExport
            dir="rtl"
            ref={(exporter) => {
              this._export = exporter
            }}
            fileName="لیست خودرو ها.xls"
          >
            <grid style={{height: '420px'}} data={this.state.excelReport}>
              <gridColumn
                key={'name'}
                field={'name'}
                title={'نام'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'description'}
                field={'description'}
                title={'توضیحات'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'enabled'}
                field={'enabled'}
                title={'وضعیت'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
            </grid>
          </ExcelExport>
        </div>

        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>اطلاعات پایه</li>
            <li>لیسست نوع اتومبیل ها</li>
          </ul>
          <div className="tableComponent">
            <div className="tableTools">
              <div className="tableOptionWrapp">
                <HeaderGrid getPageSize={this.getPageSize} createLink={''} enablePageSize />
                <button className="filterBtn">
                  <i className="fa fa-search" />
                </button>
                <button className={'printButton'} onClick={this.exportExcel}>
                  <i className="fas fa-file-excel" />
                </button>
                <button className="printButton" onClick={this.exportPrint}>
                  <i className="fas fa-print" />
                </button>
              </div>
            </div>

            <div className="filterComponent">
              <div className="filterInputs">
                <div className="formComponent">
                  <label>نام</label>
                  <input className="form-control" id="filterName" type="text" />
                </div>

                <div className="formComponent">
                  <label>توضیحات</label>
                  <textarea id="filterDescription" className="form-control" />
                </div>
              </div>
              <div className="filterOption">
                <button className="confirmFilter" onClick={this.filter.bind(this)}>
                  جست و جو
                </button>
              </div>
            </div>

            <div className="showBaseTable">
              <table className="baseTable">
                <tbody>
                  <Sort data={this.state.sortData} getSort={this.getSort} />
                  {this.state.cars.map((cars, index) => (
                    <tr key={index}>
                      <td>{(pageNumber - 1) * pageSize + index + 1}</td>
                      <td>{cars.name}</td>
                      <td>{cars.description}</td>
                      <td>
                        <button onClick={() => this.activate(index)}>
                          {cars.enabled ? (
                            <img src={require('../../image/on.svg')} alt="" />
                          ) : (
                            <img src={require('../../image/off.svg')} alt="" />
                          )}
                        </button>
                      </td>
                      <td>
                        <button onClick={() => this.editCarType(index)}>
                          <img src={require('../../image/editDriver.svg')} alt="" />
                        </button>
                      </td>
                      <td>
                        <button onClick={() => this.deleteCar(index)}>
                          <img src={require('../../image/trash.svg')} alt="" />
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <div className="paginationWrapp">
                <Pageing
                  defaultCurrent={1}
                  getPage={this.getPageNumber}
                  pageSize={this.state.pageSize}
                  currentPage={this.state.pageNumber}
                  total={this.state.lengthProducts}
                />
              </div>
            </div>
          </div>

          <Modal isOpen={this.state.modalDelete} toggle={this.deleteCancel} size="sm">
            <ModalHeader toggle={this.deleteCancel}>حذف نوع خودرو</ModalHeader>
            <ModalBody>
              <p className="titleSm">آیا از حذف خودروی {carName} مطمئن هستید؟؟؟</p>
            </ModalBody>
            <ModalFooter>
              <button className="confirmBtnModal" onClick={this.deleteOk}>
                حذف خودرو
              </button>
              <button className="cancelBtnModal" onClick={this.deleteCancel}>
                لغو
              </button>
            </ModalFooter>
          </Modal>
          <Modal isOpen={this.state.modalEdit} toggle={this.EditCancel} size="sm">
            <ModalHeader toggle={this.EditCancel}>ویرایش {carName}</ModalHeader>
            <ModalBody>
              <div className="formComponent">
                <label>نام نوع خودرو (الزامی)</label>
                <input type="text" id="name" defaultValue={carName} className="form-control" />
              </div>

              <div className="formComponent">
                <label>توضیحات (الزامی)</label>
                <textarea name="description" defaultValue={description} id="description" className="form-control" />
              </div>
            </ModalBody>
            <ModalFooter>
              <button className="confirmBtnModal" onClick={this.EditOk}>
                ویرایش خودرو
              </button>
              <button className="cancelBtnModal" onClick={this.EditCancel}>
                لغو
              </button>
            </ModalFooter>
          </Modal>
        </div>
      </div>
    )
  }
}

export default Cars
